import packageJson from '../../package.json';

/** App version shown in the UI (kept in sync with package.json). */
export const APP_VERSION = packageJson.version || '0.0.0';

export const APP_NAME = 'Prasaar';

/**
 * Old RSS ingest UI (News sources). Hidden until we wire a feed again.
 * SourcesTab and APIs stay in the repo — set this to true to show the screen again.
 */
export const SHOW_NEWS_SOURCES = false;

/** News engine scrape/import in Prasaar. Agent runs on its own — not called from Node. */
export const SHOW_NEWS_AGENT = false;
